/* pack & smooch, 12.08.2026 — Hintergrundvideos erst laden, wenn sie
   gebraucht werden, und auf dem Handy in kleiner Fassung.

   WANN geladen wird — zwei Faelle:

   In der Slideshow haengen wir uns an data-active bzw.
   data-mobile-active, die das Theme am .carousel--block ohnehin selbst
   setzt. Die Startseite hat sieben Slides, drei mit Video; bisher luden
   alle drei sofort, obwohl der erste Slide ein Bild ist.

   Ausserhalb der Slideshow — Sektionen weit unten auf Produktseiten —
   laden wir, sobald das Video in die Naehe des Sichtfelds kommt.

   Die Slideshow selbst wird nicht angefasst.

   WELCHE Fassung — ohne gepflegte Liste:

   Shopifys video_tag gibt im Storefront nur die groesste mp4 heraus.
   Die kleineren Fassungen liegen auf dem CDN, sind ueber Liquid aber
   unsichtbar. Ihre Namen enthalten die Bitrate, und die haengt vom
   Ausgangsmaterial ab (bei uns 1.5, 1.2 und 1.0 Mbps) — berechnen
   laesst sie sich also nicht.

   Aber Shopify legt zu jedem Video eine HLS-Uebersicht ab, und die
   zaehlt alle Fassungen mit exaktem Namen auf:

       #EXT-X-STREAM-INF: ... RESOLUTION=1132x480
       <hash>.SD-480p.1.5Mbps.hls.<id>_.m3u8

   Daraus bauen wir den mp4-Namen. Ein Abruf von wenigen hundert Byte,
   nur auf schmalen Bildschirmen, nur wenn das Video ohnehin lädt. Am
   12.08. gegen alle elf Autoplay-Videos geprueft: 11 von 11 richtig.

   Damit funktionieren neue Videos von selbst. Niemand muss eine Liste
   pflegen.

   Geht irgendetwas davon schief — kein HLS, Abruf fehlgeschlagen,
   Format unerwartet — nehmen wir die grosse Fassung. Wie bisher. */
(function () {
  'use strict';

  if (window.psVideoAktiv) return;
  window.psVideoAktiv = true;

  var SCHMAL = 767;
  var VORLAUF = '300px';
  var merker = {};

  /* Aus der HLS-Uebersicht die kleinste Fassung heraussuchen und daraus
     den Namen der mp4-Datei bauen. Gibt null zurueck, wenn das nicht
     zweifelsfrei geht. */
  function kleineFassung(hlsAdresse) {
    if (merker[hlsAdresse] !== undefined) return Promise.resolve(merker[hlsAdresse]);

    return fetch(hlsAdresse).then(function (antwort) {
      if (!antwort.ok) return null;
      return antwort.text();
    }).then(function (text) {
      if (!text) return null;

      var muster = /([0-9a-f]{32})\.([A-Z]{2}-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8/g;
      var kleinste = null;
      var treffer;
      while ((treffer = muster.exec(text)) !== null) {
        var hoehe = parseInt(treffer[2].replace(/\D+/g, ''), 10);
        if (kleinste === null || hoehe < kleinste.hoehe) {
          kleinste = { hoehe: hoehe, hash: treffer[1], stufe: treffer[2], rate: treffer[3], id: treffer[4] };
        }
      }
      if (!kleinste) return null;

      var datei = kleinste.hash + '.' + kleinste.stufe + '-' + kleinste.rate + '-' + kleinste.id + '.mp4';
      var ordner = hlsAdresse.slice(0, hlsAdresse.lastIndexOf('/') + 1);
      return ordner + datei;
    }).catch(function () {
      return null;
    }).then(function (ergebnis) {
      merker[hlsAdresse] = ergebnis;
      return ergebnis;
    });
  }

  function einsetzen(video, adresse) {
    if (video.dataset.psGeladen) return;
    video.dataset.psGeladen = '1';

    var s = document.createElement('source');
    s.src = adresse;
    s.type = 'video/mp4';
    video.appendChild(s);

    video.preload = 'metadata';
    video.load();

    if (video.autoplay) {
      var versuch = video.play();
      if (versuch && versuch.catch) versuch.catch(function () {});
    }
  }

  function laden(video) {
    if (video.dataset.psGeladen) return;

    var gross = video.dataset.psGross;
    if (!gross) return;

    var hls = video.dataset.psHls;
    var schmal = window.innerWidth > 0 && window.innerWidth <= SCHMAL;

    if (!schmal || !hls) {
      einsetzen(video, gross);
      return;
    }

    kleineFassung(hls).then(function (klein) {
      einsetzen(video, klein || gross);
    });
  }

  function aktiv(block) {
    return block.getAttribute('data-active') === 'true' ||
           block.getAttribute('data-mobile-active') === 'true';
  }

  function beiSlideWechsel(video, block) {
    if (aktiv(block)) {
      laden(video);
      return;
    }
    var beobachter = new MutationObserver(function () {
      if (!aktiv(block)) return;
      beobachter.disconnect();
      laden(video);
    });
    beobachter.observe(block, {
      attributes: true,
      attributeFilter: ['data-active', 'data-mobile-active']
    });
  }

  function beimHeranscrollen(video) {
    if (!('IntersectionObserver' in window)) {
      laden(video);
      return;
    }
    var beobachter = new IntersectionObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        if (!eintraege[i].isIntersecting) continue;
        beobachter.disconnect();
        laden(video);
        return;
      }
    }, { rootMargin: VORLAUF });
    beobachter.observe(video);
  }

  function begleiten(video) {
    var block = video.closest ? video.closest('.carousel--block') : null;
    if (block) {
      beiSlideWechsel(video, block);
    } else {
      beimHeranscrollen(video);
    }
  }

  function start() {
    var videos = document.querySelectorAll('video[data-ps-video]');
    for (var i = 0; i < videos.length; i++) begleiten(videos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();